import { merchantsAPI } from '@backmarket/http-api'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { omit } from '@backmarket/utils/object/omit'

import { CATEGORY_TYPES } from '../ShippingLegacy.constants'
import type { MarketShippingMethod } from '../ShippingLegacy.types'
import type { FormValues } from '../components/Form/Form.types'

export function useShippingMethodApi() {
  const tracking = useTracking()

  async function editShippingMethod(formValues: FormValues) {
    tracking.trackClick({
      zone: 'options_shipping',
      name: 'edit_backship_shipping_method',
    })

    const keysToOmit = []

    if (!formValues.categoryId) {
      keysToOmit.push('categoryId')
    }

    await $httpFetch(merchantsAPI.patchShippingMethod, {
      pathParams: {
        categoryType: formValues.categoryId ? 'categories' : 'global',
        shippingMethodId: formValues.id,
      },
      body: omit(formValues, keysToOmit),
    })
  }

  async function createShippingMethod(formValues: FormValues) {
    tracking.trackClick({
      zone: 'options_shipping',
      name: 'save_backship_shipping_method',
    })

    await $httpFetch(merchantsAPI.postShippingMethod, {
      pathParams: {
        categoryType: formValues.categoryId
          ? CATEGORY_TYPES.CATEGORY
          : CATEGORY_TYPES.GLOBAL,
      },
      body: omit(formValues, ['id']),
    })
  }

  async function deleteShippingMethod(
    marketShippingMethod: MarketShippingMethod,
  ) {
    await $httpFetch(merchantsAPI.deleteShippingMethod, {
      pathParams: {
        categoryType: CATEGORY_TYPES[marketShippingMethod.categoryType],
        shippingMethodId: marketShippingMethod.id,
      },
    })
  }

  return {
    editShippingMethod,
    createShippingMethod,
    deleteShippingMethod,
  }
}
